import { useQueryClient } from "@tanstack/react-query";
import useOrdersQueryKey from "./useOrdersQueryKey";

const useLiveOrdersRefetch = () => {
  const { branch } = useOrdersQueryKey();
  const queryClient = useQueryClient();

  // Partial key so every live-orders variant refetches (live, packaging, etc.)
  return () =>
    queryClient.refetchQueries({
      queryKey: ["v2", "orders_live", branch],
    });
};

export default useLiveOrdersRefetch;
